import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import styled from 'styled-components';
import { Column } from 'primereact/column';
import { Box } from '@mui/material';

interface DynamicTableProps {
  data: {
    columns: string[];
    values: any[][];
  };
}

export const DbDynamicTable: React.FC<DynamicTableProps> = ({ data }) => {
  const rows = data.values.map((row) => {
    const rowData: { [key: string]: any } = {};
    data.columns.forEach((col, index) => {
      rowData[col] = row[index];
    });
    return rowData;
  });

  return (
    <Box>
      <DataTable
        value={rows}
        rowHover
        size="small"
        scrollable
        scrollHeight="600px"
      >
        {data.columns.map((col) => (
          <Column key={col} field={col} header={col} sortable />
        ))}
      </DataTable>
    </Box>
  );
};
